import React, { useEffect } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";

import HeaderWrapper from "../../header/header-wrapper";
import Signup from "../../rows/Signup";
import { setCurrentPath } from "../../helper/actions";

const SignUpPageBase = ({ currentPath, setCurrentPath }) => {
  useEffect(() => {
    setCurrentPath(currentPath);
  }, []);

  return (
    <React.Fragment>
      <HeaderWrapper hideTopAd={true} />
      <Signup currentPath={currentPath} />
    </React.Fragment>
  );
};

SignUpPageBase.propTypes = {
  currentPath: string,
  setCurrentPath: func
};

const mapDispatchToProps = dispatch => ({
  setCurrentPath: path => dispatch(setCurrentPath(path))
});

export const SignUpPage = connect(null, mapDispatchToProps)(SignUpPageBase);
